import { Component, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { Config } from '../universal-config';
import { ShareCopyService } from '../share';
import { closeSelectDialog } from '../visual/visual.actions';
import { selectWorkspace } from '../workspaces/workspaces.actions';

@Component({
  selector: 'nns-select-dialog',
  template: `
    <div class="nns-select-dialog-content" flex="noshrink" layout="column">

      <div class="nns-dialog-subtitle">Organization:</div>
      <nns-organization-select
        [profile]="profile"
        [organizations]="organizations"
        [selectedOrganization]="selectedOrganization"
        ></nns-organization-select>

      <div class="nns-select-separator"></div>

      <div class="nns-dialog-subtitle">Workspace:</div>
      <nns-workspace-select
        [workspaces]="workspaces"
        [selectedWorkspace]="selectedWorkspace"
        [ownerId]="profile ? profile.userId : null"
        (onSelectWorkspaceEvent)="onSelectWorkspace($event)"
        ></nns-workspace-select>
      <div class="nns-btn-wrapper">
        <button
          class="nns-cancel-button"
          (click)="close()"
          >Cancel</button>
        <button
          class="nns-save-button"
          (click)="saveNote()"
          >Save</button>
      </div>

    </div>
  `,
  styles: [`
    .nns-select-dialog-title{
      font-size: 13px;
      font-weight: bold;
    }

    .icon-close, .icon-close-white{
      min-height: 16px;
      min-width: 16px;
      cursor: pointer;
    }

    .nns-btn-wrapper{
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
    }

    .nns-select-separator{
      height: 1px;
      width: 100%;
      background-color: #E4E4E4;
      margin: 10px 0;
    }

    .nns-cancel-button{
      color: #0096A7;
      font-size: 13px
      line-height: 150%;
      padding: 6px 16px;
      margin-right: 8px;
      background-color: transparent;
      border: none;
      outline: none;
      font-weight: bold;
      cursor: pointer;
    }

    .nns-save-button{
      background: #0096A7;
      font-weight: bold;
      color: #fff;
      border: none;
      outline: none;
      padding: 6px 16px;
      border-radius: 16px;
      font-size: 13px;
      line-height: 150%;
      cursor: pointer;
    }

    .nns-dialog-subtitle{
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .nns-select-dialog-content{
      padding: 14px 8px 12px;
    }

  `, `
    :host-context(.nns-theme-night) {
      background:#414B4C;
    }
  `]
})
export class SelectDialogComponent {
  @Input() profile;
  @Input() organizations;
  @Input() selectedOrganization;
  @Input() workspaces;
  @Input() selectedWorkspace;
  @Input() state;
  @Input() visual;

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
    public _shareCopyService: ShareCopyService,
  ) { }

  @HostListener('document:keydown.esc', ['$event'])
  close() {
    this._store.dispatch(closeSelectDialog());
  }

  onSelectWorkspace(workspaceId) {
    this._store.dispatch(selectWorkspace(workspaceId));
  }

  saveNote() {
    this._shareCopyService.copy();
    this.close();
  }
}
